var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClockOutline2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_893_41296)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5 2.37109C13.8043 2.37109 11.1692 3.17046 8.92778 4.6681C6.6864 6.16574 4.93946 8.2944 3.90786 10.7849C2.87627 13.2754 2.60635 16.0158 3.13226 18.6597C3.65816 21.3036 4.95626 23.7322 6.86239 25.6383C8.76853 27.5445 11.1971 28.8426 13.841 29.3685C16.4849 29.8944 19.2253 29.6244 21.7158 28.5929C24.2063 27.5613 26.335 25.8143 27.8326 23.5729C29.3303 21.3316 30.1296 18.6964 30.1296 16.0007C30.1296 14.2109 29.7771 12.4385 29.0921 10.7849C28.4072 9.13126 27.4032 7.62875 26.1376 6.36312C24.872 5.09749 23.3694 4.09354 21.7158 3.40859C20.0622 2.72363 18.2899 2.37109 16.5 2.37109ZM16.5 26.9044C14.3434 26.9044 12.2353 26.2649 10.4422 25.0668C8.64912 23.8687 7.25156 22.1658 6.42629 20.1734C5.60101 18.181 5.38508 15.9886 5.8058 13.8735C6.22653 11.7584 7.265 9.81555 8.78991 8.29064C10.3148 6.76573 12.2577 5.72725 14.3728 5.30653C16.4879 4.88581 18.6803 5.10174 20.6727 5.92701C22.6651 6.75229 24.368 8.14984 25.5661 9.94295C26.7642 11.7361 27.4037 13.8442 27.4037 16.0007C27.4037 18.8926 26.2549 21.666 24.2101 23.7108C22.1652 25.7556 19.3918 26.9044 16.5 26.9044Z",
    fill: "#FF5B00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6357 15.0133H17.4876V10.8651C17.4876 10.4984 17.3419 10.1467 17.0826 9.88741C16.8233 9.6281 16.4716 9.48242 16.1049 9.48242C15.7382 9.48242 15.3865 9.6281 15.1272 9.88741C14.8678 10.1467 14.7222 10.4984 14.7222 10.8651V16.396C14.7222 16.7627 14.8678 17.1144 15.1272 17.3737C15.3865 17.633 15.7382 17.7787 16.1049 17.7787H21.6357C22.0025 17.7787 22.3542 17.633 22.6135 17.3737C22.8728 17.1144 23.0185 16.7627 23.0185 16.396C23.0185 16.0293 22.8728 15.6776 22.6135 15.4183C22.3542 15.159 22.0025 15.0133 21.6357 15.0133Z",
    fill: "#FF5B00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_893_41296"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockOutline2);
export default __webpack_public_path__ + "static/media/clockOutline2.7f1fd884ca0a78ddcfac8d6019f80826.svg";
export { ForwardRef as ReactComponent };